module.exports = __webpack_public_path__ + "img/dentaliaPay.afbfcc96.png";